"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DNDItem = exports.DnDListContainer = void 0;
var styled_components_1 = __importDefault(require("styled-components"));
exports.DnDListContainer = styled_components_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  background: ", ";\n  padding: ", ";\n  margin: ", ";\n  display: ", ";\n  overflow: ", ";\n  width: ", ";\n  min-width: ", ";\n  height: ", ";\n  min-height: ", ";\n"], ["\n  background: ", ";\n  padding: ", ";\n  margin: ", ";\n  display: ", ";\n  overflow: ", ";\n  width: ", ";\n  min-width: ", ";\n  height: ", ";\n  min-height: ", ";\n"])), function (props) {
    return props.isDragging
        ? props.dragColor
            ? props.dragColor
            : 'lightblue'
        : props.background
            ? props.background
            : '#eae8e8';
}, function (props) { return (props.padding ? props.padding : '5px'); }, function (props) { return (props.margin ? props.margin : 0); }, function (props) {
    return props.direction === 'horizontal' ? 'flex' : 'inherit';
}, function (props) {
    return props.direction === 'horizontal' ? 'auto' : 'inherit';
}, function (props) { return (props.width ? props.width : 'auto'); }, function (props) {
    return props.direction === 'horizontal' ? '100%' : '250px';
}, function (props) { return (props.height ? props.height : 'auto'); }, function (props) {
    return props.direction === 'horizontal' ? '100%' : '100px';
});
exports.DNDItem = styled_components_1.default.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  padding: ", ";\n  margin: ", ";\n  ...draggableStyle;\n"], ["\n  padding: ", ";\n  margin: ", ";\n  ...draggableStyle;\n"])), function (props) { return (props.padding ? props.padding : '5px'); }, function (props) { return (props.margin ? props.margin : 0); });
var templateObject_1, templateObject_2;
